var map = {
	"./admins/admins.module": [
		"./src/app/pages/admins/admins.module.ts",
		"default~admins-admins-module~inbox-inbox-module~tags-tags-module~users-users-module",
		"admins-admins-module"
	],
	"./change-password/change-password.module": [
		"./src/app/pages/change-password/change-password.module.ts",
		"change-password-change-password-module"
	],
	"./inbox/inbox.module": [
		"./src/app/pages/inbox/inbox.module.ts",
		"default~admins-admins-module~inbox-inbox-module~tags-tags-module~users-users-module",
		"inbox-inbox-module"
	],
	"./profile/profile.module": [
		"./src/app/pages/profile/profile.module.ts",
		"profile-profile-module"
	],
	"./tags/tags.module": [
		"./src/app/pages/tags/tags.module.ts",
		"default~admins-admins-module~inbox-inbox-module~tags-tags-module~users-users-module",
		"tags-tags-module"
	],
	"./users/users.module": [
		"./src/app/pages/users/users.module.ts",
		"default~admins-admins-module~inbox-inbox-module~tags-tags-module~users-users-module",
		"users-users-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;